import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Input, InputNumber } from "antd";
import { API_URLS } from "../../../api/apiUrls";
import { putApi } from "../../../api/api_instance";

const EditLicenseCostDialog = ({ onOpen, onClose, licenseData, onUpdate, onError }) => {
  const [role, setRole] = useState("");
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState({
    role: "",
    price: "",
  });

  useEffect(() => {
    if (licenseData) {
      setRole(licenseData.role || "");
      setPrice(licenseData.price ? licenseData.price : null);
    }
  }, [licenseData]);

  const handleSave = async () => {
    let isValid = true;
    const errors = { role: "", price: "" };

    if (!role.trim()) {
      errors.role = "Role is required";
      isValid = false;
    }
    if (price === undefined || price === null || price < 0) {
      errors.price = "Valid price is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);

    try {
      const response = await putApi({
        apiUrl: API_URLS.EDIT_LICENSE_COST(licenseData._id),
        data: { role, price },
      });

      if (response.success) {
        if (onUpdate) onUpdate();
        onClose();
      } else {
        if (onError)
          onError(response.message || "Update failed.");
      }
    } catch (error) {
      if (onError)
        onError(error.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="600px">
      <div>
        <h3 className="text-xl font-bold text-[#06513D]">
          Edit License Cost
        </h3>
      </div>
      <div className="rounded-xl border mt-8 px-12">
        <div className="mt-3 mb-4">
          <hr />
        </div>

        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <label htmlFor="role" className="text-sm font-medium text-gray-700 text-left">License Type / Role</label>
            <Input
              id="role"
              value={role}
              disabled
              placeholder="e.g. Sub admin"
              className="h-14 rounded-lg"
            />
            {errorMessage.role && (
              <div className="text-red-500 text-sm text-left mt-1">
                {errorMessage.role}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="price" className="text-sm font-medium text-gray-700 text-left">Price per License (₹)</label>
            <InputNumber
              id="price"
              value={price}
              onChange={(value) => setPrice(value)}
              placeholder="Price"
              className="w-full h-14 rounded-lg flex items-center"
             
            />
            {errorMessage.price && (
              <div className="text-red-500 text-sm text-left mt-1">
                {errorMessage.price}
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-center gap-6 p-5 mt-6">
          <CustomButton
            buttonType="button"
            variant="cancel"
            buttonText="Cancel"
            onClick={onClose}
            className="text-base font-normal h-[50px] w-[160px]"
          />

          <CustomButton
            buttonType="button"
            variant="ok"
            buttonText="Save"
            onClick={handleSave}
            loading={loading}
            className="text-base font-normal h-[50px] w-[160px]"
          />
        </div>
      </div>
    </DailogBox>
  );
};

export default EditLicenseCostDialog;
